import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'extra-rewards',
  templateUrl: './extra-rewards.component.html',
  styleUrls: ['./extra-rewards.component.less'],
})
export class ExtraRewardsComponent implements OnInit {
  services = [
    {
      icon: 'assets/official-website/team-3-b.png',
      title: '专业',
      description: '成为博世柴油维修厂后，您将成为您所在地专业柴油维修的专业提供者。您的专业以及博世的技术知识和支援将改善您现有的业务。'
    },
    {
      icon: 'assets/official-website/label-b.png',
      title: '强势品牌',
      description: '博世全球品牌的力量和声誉将使您成为综合维修厂和车队的不二之选。'
    },
    {
      icon: 'assets/official-website/welcome-b.png',
      title: '维修合作伙伴',
      description: '我们也仰赖您作为我们的维修合作伙伴来处理我们博世柴油产品的保固。'
    },
    {
      icon: 'assets/official-website/wrench-b.png',
      title: '高品质的设备',
      description: '身为博世柴油维修厂，您将可以使用最新的诊断和测试设备。'
    }
  ];
  constructor(
  ) { }

  ngOnInit(): void {
  }

}
